import { clsx as e } from "clsx";
import { twMerge as t } from "tailwind-merge";
// libs/ui-lib/src/lib/utils.ts
function n(...n) {
	return t(e(n));
}
function r(e) {
	let t = e.trim();
	if (!t) return null;
	let [n = "", ...r] = t.split(":");
	if (!r.length) return null;
	let i = n.trim(), a = r.join(":").trim();
	return !i || !a ? null : {
		field: i,
		value: a
	};
}
export { n as cn, r as parseFieldValueInput };
